import {Discount} from "./discount";

export class Discounts {
    total: number;
    items: Discount[];
}
